// @givmo/employer-module — the Security panels' card titles WRAP (AS-WEB8, D-AS-38 (1)).
//
// The design system's `CardHeader` truncates its title to one line, which cut "Step 4 · Choose what
// employees sign in wi…" off on a 390px phone. These titles are sentences an Owner reads whole, so
// every card in the panels lets its title wrap — balanced (`text-wrap: balance`), so a two-line title
// breaks evenly. A class on these headers rather than a change to the shared component: every other
// card in the product keeps its one-line truncation.
export const WRAPPING_CARD_TITLE = '[&_h3]:whitespace-normal [&_h3]:text-balance';
